export default {
  ITEMS_FIND_ALL: 'ITEMS_FIND_ALL',
  SELECTED_SOLUTION: 'SELECTED_SOLUTION',
  SELECTED_TYPE: 'SELECTED_TYPE'
};
